import LoadingButton from "@mui/lab/LoadingButton";
import {
  Box,
  Card,
  CardContent,
  Checkbox,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

function DefaultSMS(props) {
  

  const fields = ["WelcomeSMS", "OTP Notification", "Payment SMS"];

  return (
    <Stack>
      <Typography>Set Default SMS</Typography>
      <Divider variant="middle" />
      <Stack rowGap={1}>
        {fields.map((field, index)=>{
        return(
        <Card key={index}>
          <CardContent>
            <Box display={"flex"} alignItems={"center"}>
              <Typography variant="body1">{field}</Typography>
              <Checkbox id="enable" sx={{ ml: "auto" }}>
                Enable
              </Checkbox>
            </Box>
            <Box display={"flex"}>
              <TextField
                size="small"
                label="Message"
                id="payment"
                name="payment"
                fullWidth
              />
            </Box>
            <Box display={"flex"} mt={2}>
              <LoadingButton
                variant="outlined"
                sx={{ borderRadius: 4, ml: "auto" }}
              >
                Update
              </LoadingButton>
            </Box>
          </CardContent>
        </Card>
        )})}
      </Stack>
    </Stack>
  );
}

export default DefaultSMS;
